import React, { useContext } from 'react';
import { PageContext } from '@/context/PageContext';
import { Box } from '@latitude/box';
import { SecondaryHero } from '@latitude/hero';
import  {AccordionFaqSidebar}  from '@latitude/accordion-rebrand';
import { Metadata } from '@latitude/metadata';
import Layout from '@/components/layout';
import { REBRAND_COLOR, SITE_URL } from '@/utils/constants';

import faqs from './_faqs';
import GemMicrositeHeader from './_gem-microsite-header';
import HeroV2 from '@/components/Hero/HeroV2/HeroV2';;
import Section from '@latitude/section-rebrand';
import FaqHero from './faqHero';

const Faqs = ({ location }) => {
    const contentfulPageData = useContext(PageContext);
    const state = contentfulPageData?.updatedBody || {};
    console.log('state =', state);

  return (
    <Layout location={location} hasSecNav>
      <main
              className="navigation-spacer"
        css={`
          margin-top: 130px !important;
          background-color: #f8f8f8;
          .microsite-header {
            z-index: 2000 !important;
          }

          div[class^='MicrositeHeader__SecondBar'].microsite-header__nav-wrap {
            margin-top: 8px;
          }
          div[class^='MicrositeHeader__HeaderPlaceholder']{
            height: auto ;}
        `}
      >
        <Metadata
          title={`FAQs | Gem Visa`}
          description={`Learn all the handy hints, tips, and answers for everything you wanted to know about your Gem Visa credit card`}
          keywords="FAQ"
          canonical={`${SITE_URL}${location.pathname}`}
        />
        <div>
        <GemMicrositeHeader data={state.secondaryNavData} />
        </div>

        <FaqHero />
          <Section css={`
            padding: 48px 20px;
            `}>
          <AccordionFaqSidebar data={faqs.items} />
          </Section>
      </main>
    </Layout>
  )
};


export default Faqs;
